import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { host } from '../../configuraciones'
import axios from 'axios'

const dataInicial = {
    zonas: [

    ],
    localidades: [

    ]

}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const OBTENER_DATOS_GET_ZONAS_EXITO = 'OBTENER_DATOS_GET_ZONAS_EXITO'
const OBTENER_DATOS_GET_ZONA_BY_ID_EXITO = 'OBTENER_DATOS_GET_ZONA_BY_ID_EXITO'
const AGREGAR_DATOS_INSERT_ZONA_EXITO = 'AGREGAR_DATOS_INSERT_ZONA_EXITO'
const ACTUALIZAR_DATOS_UPDATE_ZONA_EXITO = 'ACTUALIZAR_DATOS_UPDATE_ZONA_EXITO'
const DELETE_ZONA = 'DELETE_ZONA'
const HABILITAR_ZONA = 'HABILITAR_ZONA'

const INSERT_LOCALIDAD = 'INSERT_LOCALIDAD'
const GET_ZONAS_BY_ID = 'GET_ZONAS_BY_ID'
const UPDATE_LOCALIDAD = 'UPDATE_LOCALIDAD'
const DELETE_LOCALIDAD = 'DELETE_LOCALIDAD'

//*******************************************************************************************************************





//MÉTODOS
export const getZonas = createAsyncThunk(
    OBTENER_DATOS_GET_ZONAS_EXITO,
    async () => {
        try {
            const fullUrl = host + `Zonas/obtenerZonas`
            const res = await axios.get(fullUrl)
            //console.log('Obtengo zonas: ' + JSON.stringify(res))
            //console.log('-----------------------')
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getZonasById = createAsyncThunk(
    OBTENER_DATOS_GET_ZONA_BY_ID_EXITO,
    async (idZona) => {
        try {
            const fullUrl = host + `Zonas/obtenerZonaById/${idZona}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertZona = createAsyncThunk(
    AGREGAR_DATOS_INSERT_ZONA_EXITO,
    async (data) => {
        try {
            //console.log('Zona que se envía es: '+JSON.stringify(data))
            const fullUrl = host + `Zonas/agregarZona`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateZona = createAsyncThunk(
    ACTUALIZAR_DATOS_UPDATE_ZONA_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `Zonas/actualizarZona`
            //alert(JSON.stringify('data actualizar:'+JSON.stringify(data)))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const reAsignarAsociado = createAsyncThunk(

)
export const agregarInstalacionAsociado = createAsyncThunk(

)
export const eliminarInspectorDeZona = createAsyncThunk(

)
export const sustituirInspector = createAsyncThunk(

)
export const agregarZona = createAsyncThunk(

)
export const editarZona = createAsyncThunk(

)

export const eliminarZona = createAsyncThunk(
    DELETE_ZONA,
    async (idzona) => {
        try {
            const fullUrl = host + `Zonas/eliminarZona/${idzona}`
            const result = await axios.put(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const habilitarZona = createAsyncThunk(
    HABILITAR_ZONA,
    async (idzona) => {
        try {
            const fullUrl = host + `Zonas/habilitarZona/${idzona}`
            const result = await axios.put(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

/******************** LOCALIDADES  ************************** */
export const getLocalidadesByZona = createAsyncThunk(
    GET_ZONAS_BY_ID,
    async (idZona) => {
        try {
            console.log('obtengo las localidades de:' + idZona)
            const fullUrl = host + `Localidades/obtenerLocalidadesByIdZona/${idZona}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)


export const agregarLocalidad = createAsyncThunk(
    INSERT_LOCALIDAD,
    async (data) => {
        try {
            console.log('Localidad que se envía es: ' + JSON.stringify(data))
            const fullUrl = host + `Localidades/agregarLocalidad`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }

)

export const editarLocalidad = createAsyncThunk(
    UPDATE_LOCALIDAD,
    async (data) => {
        try {
            const fullUrl = host + `Localidades/actualizarLocalidad`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log('No lo hice: ' + JSON.stringify(data))
            console.log(error);
        }
    }
)

export const eliminarLocalidad = createAsyncThunk(
    DELETE_LOCALIDAD,
    async (data) => {
        try {
            const fullUrl = host + `Localidades/eliminarLocalidad/${data}`
            const result = await axios.delete(fullUrl, data)
            return result
        } catch (error) {
            console.log(error)
        }
    }
)


export const activarAsociado = createAsyncThunk(

)
//****************************************************************************************************************
//EXPORTS DE MÉTODOS

export const metodosZonaSlice = createSlice({

    name: 'metodosZonaSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getZonas.fulfilled]: (state, { payload }) => {
            state.zonas = payload.data.data
        },
        [insertZona.fulfilled]: (state, { payload }) => {

        },
        [getLocalidadesByZona.fulfilled]: (state, { payload }) => {
            state.localidades = payload.data.data
        },

        [updateZona.fulfilled]: (state, { payload }) => {

        },

        [getZonasById.fulfilled]: (state, { payload }) => {

        },

        [reAsignarAsociado.fulfilled]: (state, { payload }) => {

        },

        [agregarInstalacionAsociado.fulfilled]: (state, { payload }) => {

        },

        [eliminarInspectorDeZona.fulfilled]: (state, { payload }) => {

        },

        [sustituirInspector.fulfilled]: (state, { payload }) => {

        },

        [agregarZona.fulfilled]: (state, { payload }) => {

        },

        [editarZona.fulfilled]: (state, { payload }) => {

        },

        [editarLocalidad.fulfilled]: (state, { payload }) => {

        },

        [eliminarZona.fulfilled]: (state, { payload }) => {

        },
        [habilitarZona.fulfilled]: (state, { payload }) => {

        },

        [agregarLocalidad.fulfilled]: (state, { payload }) => {

        },

        [eliminarLocalidad.fulfilled]: (state, { payload }) => {

        },

        [activarAsociado.fulfilled]: (state, { payload }) => {

        }

    },

})

export const { } = metodosZonaSlice.actions
export const ZonaReducer = metodosZonaSlice.reducer



